import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { DateField } from "@/components/ui/date-field";

const MONTHS = [
  { value: 1, label: "Janv" }, { value: 2, label: "Fév" }, { value: 3, label: "Mars" },
  { value: 4, label: "Avr" }, { value: 5, label: "Mai" }, { value: 6, label: "Juin" },
  { value: 7, label: "Juil" }, { value: 8, label: "Août" }, { value: 9, label: "Sept" },
  { value: 10, label: "Oct" }, { value: 11, label: "Nov" }, { value: 12, label: "Déc" },
];

function getYearOptions() {
  const current = new Date().getFullYear();
  const years = [];
  for (let y = current; y >= current - 5; y--) years.push(y);
  return years;
}

export function PeriodSelector({ noPeriodFilter, setNoPeriodFilter, selectedYear, setSelectedYear, fullYear, setFullYear, selectedMonth, setSelectedMonth, useCustomDates, setUseCustomDates, customStart, setCustomStart, customEnd, setCustomEnd }) {
  return (
    <Card className="p-4 border border-slate-200 rounded-lg bg-white mb-4" data-testid="period-selector">
      <div className="flex flex-wrap items-center gap-2 mb-2">
        <Button size="sm" variant={noPeriodFilter ? "default" : "outline"} className="h-7 text-xs px-3"
          onClick={() => { setNoPeriodFilter(true); setUseCustomDates(false); }}
          data-testid="all-dates-btn">
          Toutes
        </Button>
        <span className="mx-0.5 text-slate-300">|</span>
        {getYearOptions().map(y => (
          <Button key={y} size="sm" variant={selectedYear === y && !noPeriodFilter && !useCustomDates && fullYear ? "default" : "outline"} className="h-7 text-xs px-3"
            onClick={() => { setSelectedYear(y); setFullYear(true); setSelectedMonth(null); setUseCustomDates(false); setNoPeriodFilter(false); }}
            data-testid={`year-btn-${y}`}>
            {y}
          </Button>
        ))}
        <span className="mx-0.5 text-slate-300">|</span>
        <button className="text-xs text-indigo-600 hover:underline" onClick={() => { setUseCustomDates(!useCustomDates); setNoPeriodFilter(false); }} data-testid="toggle-custom-dates">
          Dates
        </button>
      </div>
      {!noPeriodFilter && !useCustomDates && (
        <div className="flex flex-wrap gap-1">
          <Button size="sm" variant={fullYear ? "default" : "ghost"} className="h-6 text-[11px] px-2"
            onClick={() => { setFullYear(true); setSelectedMonth(null); }}>
            Année
          </Button>
          {MONTHS.map(m => (
            <Button key={m.value} size="sm" variant={selectedMonth === m.value && !fullYear ? "default" : "ghost"} className="h-6 text-[11px] px-2"
              onClick={() => { setSelectedMonth(m.value); setFullYear(false); setUseCustomDates(false); setNoPeriodFilter(false); }}
              data-testid={`month-btn-${m.value}`}>
              {m.label}
            </Button>
          ))}
        </div>
      )}
      {!noPeriodFilter && useCustomDates && (
        <div className="flex items-center gap-2 mt-1">
          <DateField value={customStart} onChange={e => setCustomStart(e.target.value)} className="h-7 text-xs w-36" data-testid="custom-date-from" />
          <span className="text-xs text-slate-400">a</span>
          <DateField value={customEnd} onChange={e => setCustomEnd(e.target.value)} className="h-7 text-xs w-36" data-testid="custom-date-to" />
        </div>
      )}
    </Card>
  );
}
